import { defineComponent as _defineComponent } from 'vue'
import { Client, OnboardingIndividualInfo } from 'ah-api-gateways';
import { ref } from 'vue';
import { BModal } from 'bootstrap-vue';
import { InformationIcon } from 'ah-common-lib/src/icons/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientRejectionModal',
  props: {
    client: null,
    applicant: null
  },
  emits: ["reject-application"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'reject-application'): void;
}), expose: any, slots: any, attrs: any }) {



const modal = ref<InstanceType<typeof BModal> | null>(null);



function show() {
  modal.value?.show();
}

function reject() {
  emit('reject-application');
}

return { __sfc: true,modal, emit, show, reject, BModal, InformationIcon }
}

})